import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../store/DataContext';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
export const Login: React.FC = () => {
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const {
    login
  } = useData();
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const result = login(fullName, password);
    if (result.ok) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Invalid username or password');
    }
  };
  return <div className="min-h-screen flex items-center justify-center px-4" style={{
    background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 50%, #f43f5e 100%)'
  }} data-id="element-3013">
      <div className="w-full max-w-md" data-id="element-3014">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-3015">
          {/* Header Section */}
          <div className="pt-10 pb-6 px-8 text-center" data-id="element-3016">
            <div className="flex justify-center mb-4" data-id="element-3017">
              <div className="h-28 w-28 rounded-full border-4 border-purple-500 p-1 flex items-center justify-center bg-white shadow-lg" data-id="element-3018">
                <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="h-20 w-20 object-contain rounded-full" data-id="element-3019" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-pink-600 tracking-wide" data-id="element-3020">
              BMED MEDICAL CENTRE
            </h1>
            <p className="text-sm text-gray-500 mt-1" data-id="element-3021">Caring Healing Leading</p>
          </div>

          {/* Form Section */}
          <div className="px-8 pb-8" data-id="element-3022">
            <form onSubmit={handleLogin} className="space-y-5" data-id="element-3023">
              <div data-id="element-3024">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3025">
                  Full Name
                </label>
                <div className="relative" data-id="element-3026">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3027">
                    <User className="h-5 w-5 text-gray-400" data-id="element-3028" />
                  </div>
                  <input type="text" required value={fullName} onChange={e => setFullName(e.target.value)} placeholder="e.g. Chanda Mwale" className="block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors" data-id="element-3029" />
                </div>
              </div>

              <div data-id="element-3030">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3031">
                  Password
                </label>
                <div className="relative" data-id="element-3032">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-3033">
                    <Lock className="h-5 w-5 text-gray-400" data-id="element-3034" />
                  </div>
                  <input type={showPassword ? 'text' : 'password'} required value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-xl text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors" data-id="element-3035" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-3036">
                    {showPassword ? <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-3037" /> : <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" data-id="element-3038" />}
                  </button>
                </div>
                <p className="mt-1.5 text-xs text-gray-400" data-id="element-3039">
                  Min 6 chars, with numbers &amp; signs
                </p>
              </div>

              {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-xl border border-red-200 text-center" data-id="element-3040">
                  {error}
                </div>}

              <button type="submit" className="w-full py-3.5 rounded-xl text-white font-semibold text-base shadow-lg hover:shadow-xl transition-all duration-200 hover:opacity-95 active:scale-[0.98]" style={{
              background: 'linear-gradient(90deg, #ec4899 0%, #f43f5e 100%)'
            }} data-id="element-3041">
                Sign In
              </button>
            </form>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-white text-xs mt-6 opacity-80" data-id="element-3042">
          © 2026 BMED Medical Centre. All rights reserved.
        </p>
      </div>
    </div>;
};